import React from 'react';
import { Badge, Box, Text } from '@wix/design-system';
import { WidgetButton } from '../../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { WidgetLayout } from '../../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { useActiveWidget } from '../../../../shared/active-widget/useActiveWidget';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
import { StyledMarkdownText } from '../../ProactiveMarketingAssistant/common/TextTyper/StyledMarkdownText';
import { useHasSubsequentRestoreNotification } from './hooks/useHasSubsequentRestoreNotification';
import styles from './CheckpointWidget.module.scss';
export const CheckpointWidget = _ref => {
  var _actionButton$sideEff, _actionButton$sideEff2;
  let {
    data: {
      actionButton,
      previewButton,
      header,
      body,
      timestamp
    },
    context,
    config
  } = _ref;
  const {
    isLatestInstance,
    makeLatest
  } = useActiveWidget(config);
  const hasSubsequentRestoreNotification = useHasSubsequentRestoreNotification(config);
  const areControlsDisabled = false;
  const enableControls = makeLatest;
  const shouldShowPastState = !isLatestInstance || hasSubsequentRestoreNotification;
  const actionButtonSideEffect = {
    name: (actionButton == null || (_actionButton$sideEff = actionButton.sideEffect) == null ? void 0 : _actionButton$sideEff.name) ?? 'checkpoint_widget_action_button_click',
    params: {
      messageIndex: config.messageIndex,
      action: shouldShowPastState ? 'restore' : 'undo',
      ...((actionButton == null || (_actionButton$sideEff2 = actionButton.sideEffect) == null ? void 0 : _actionButton$sideEff2.params) ?? {})
    }
  };
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(CHECKPOINT_WIDGET, onWidgetActionData);
    };
    return handler;
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    boxSizing: "border-box",
    containerType: "inline-size",
    gap: "10px"
  }, typeof timestamp === 'number' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
    noPadding: true,
    className: styles.timestamp,
    type: "transparent"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookmarkGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0021FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5FF2AE"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 1.44772 3.44772 1 4 1H12C12.5523 1 13 1.44772 13 2V14.5C13 14.7761 12.7761 15 12.5 15C12.3674 15 12.2402 14.9473 12.1464 14.8536L8 10.7071L3.85355 14.8536C3.65829 15.0488 3.34171 15.0488 3.14645 14.8536C3.05268 14.7598 3 14.6326 3 14.5V2Z",
    fill: "url(#bookmarkGradient)"
  })), new Date(timestamp).toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).replace(',', '')))), (header || body) && /*#__PURE__*/React.createElement("div", {
    className: styles.appliedActionContainer
  }, header && /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    className: styles.actionHeader
  }, header)), body && /*#__PURE__*/React.createElement(StyledMarkdownText, {
    className: styles.actionBody
  }, body)), /*#__PURE__*/React.createElement(Box, {
    align: "space-between"
  }, (actionButton == null ? void 0 : actionButton.activeStateLabel) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: () => {}
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    className: styles.actionButton,
    context: context,
    onClick: handleButtonClick('primary_button_click', shouldShowPastState ? actionButton.pastStateLabel : actionButton.activeStateLabel),
    respondText: actionButton.respondText,
    icon: {
      name: shouldShowPastState ? 'History' : 'Revert',
      place: 'prefix'
    },
    sideEffect: actionButtonSideEffect,
    disabled: areControlsDisabled,
    priority: "secondary"
  }, shouldShowPastState ? actionButton.pastStateLabel : actionButton.activeStateLabel)), (previewButton == null ? void 0 : previewButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: enableControls
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    context: context,
    onClick: handleButtonClick('secondary_button_click', previewButton == null ? void 0 : previewButton.label),
    webAction: previewButton.webAction,
    respondText: previewButton.respondText,
    icon: previewButton.icon,
    sideEffect: previewButton.sideEffect
  }, previewButton.label)))));
};
export const CHECKPOINT_WIDGET = 'CHECKPOINT_WIDGET';
//# sourceMappingURL=CheckpointWidget.js.map